import { createEntityAdapter } from '@reduxjs/toolkit';

import { TagEntityModel } from 'core/entities';

export const chainsReportChainsEntityAdapter = createEntityAdapter<
    TagEntityModel
>({
    selectId: (entityModel) => entityModel.uid,
});
